// extracted by mini-css-extract-plugin
export default {"blue":"confirm_blue__g7TZT","red":"confirm_red__KBLR9","modal":"confirm_modal__HjYX-"};